@if (!isAllowedGlobalStyling) {
<div
  class="h-100 w-100 position-relative cursor-pointer pointer-events-none bg-transparent webkit-tap-highlight-color-transparent"
  (click)="
    goToLink(
      quickLinksData.url,
      quickLinksData.role
    )
  "
>
  <button
    class="title"
    style="width: -webkit-fill-available"
    [ngClass]="pageConfig?.isUsingHtmlStructure ? '' : 'position-absolute-fill'"
    [ngStyle]="contentStyle"
  >
    @if (quickLinksData?.icon && quickLinksData?.icon !== '') {
    <mat-icon
      svgIcon="{{ quickLinksData.icon }}"
      [ngStyle]="iconStyle"
      [ngClass]="quickLinksData.title.length <= 0 ? '' : 'mr-2'"
    ></mat-icon>
    }
    @if (quickLinksData.title.length > 0) {
    <span class="w-100" [ngStyle]="textContentStyle" [innerHTML]="quickLinksData.title | safeHtml"></span>
    }
  </button>
</div>
}

<!-- If isAllowedGlobalStyling is true, the Quick link acts as a button -->

@if (isAllowedGlobalStyling) {
<div #buttonContent class="h-100">
  <finx-button
    [labeltext]="quickLinksData?.title ?? ''"
    class="pointer-events-none d-flex"
    [class]="globalStylingClass"
    [rightIcon]="quickLinksData?.icon ?? ''"
    [rightIconSize]="iconStyle"
    [isAllowedGlobalStyling]="isAllowedGlobalStyling"
    [activationDelaySeconds]="activationDelaySeconds()"
    (click)="
      goToLink(
        quickLinksData.url,
        quickLinksData.role
      )
    "
    [style.height]="'100%'"
    [buttonStyle]="buttonStyles"
  ></finx-button>
</div>
}
